import React from "react";
import "./index.css";

// Mock translation function for demo
const mockTranslations = {
  mcb: "Macbook",
  bansub: "Now with the ultimate full hd display",
  spnow: "Shop Now",
  svaio: "Sony VAIO",
  cptr: "Computer",
  phone: "Phone"
};

const mockT = (key) => mockTranslations[key] || key;

const SingleBanner = ({ t = mockT, title, subtitle, buttonText, gradient = "linear-gradient(135deg, rgba(243, 51, 51, 0.9), rgba(243, 51, 51, 0.7))" }) => {
  // Mock image - in real app this would be imported
  const bannerImage = "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80";

  return (
    <div className="banner-card">
      <div className="banner-image-container">
        <img src={bannerImage} alt="Banner" className="banner-image" />
        <div className="banner-overlay" style={{ background: gradient }}>
          <div className="banner-content">
            <h2 className="banner-title">{title || t("mcb")}</h2>
            <p className="banner-subtitle">{subtitle || t("bansub")}</p>
            <button className="banner-button">
              <span>{buttonText || t("spnow")}</span>
              <div className="button-arrow">→</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Banners = ({ t = mockT }) => {
  const bannerData = [
    {
      title: t("mcb"),
      subtitle: t("bansub"),
      buttonText: t("spnow"),
      gradient: "linear-gradient(135deg, rgba(243, 51, 51, 0.9), rgba(243, 51, 51, 0.7))"
    },
    {
      title: t("svaio"),
      subtitle: "Cutting-edge technology meets elegant design",
      buttonText: t("spnow"),
      gradient: "linear-gradient(135deg, rgba(51, 122, 243, 0.9), rgba(51, 122, 243, 0.7))"
    },
    {
      title: t("phone"),
      subtitle: "Latest smartphones with premium features",
      buttonText: t("spnow"),
      gradient: "linear-gradient(135deg, rgba(40, 167, 69, 0.9), rgba(40, 167, 69, 0.7))"
    }
  ];

  return (
    <div className="container"
    // style={styles.container}
    >
      <div className="bannersGrid"
      // style={styles.bannersGrid}
      >
        {bannerData.map((banner, index) => (
          <SingleBanner
            key={index}
            t={t}
            title={banner.title}
            subtitle={banner.subtitle}
            buttonText={banner.buttonText}
            gradient={banner.gradient}
          />
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 20px',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'
  },
  bannersGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '30px',
    alignItems: 'stretch'
  }
};

// Internal CSS as a style tag
const internalCSS = `
  .banner-card {
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    height: 400px;
    background: #fff;
  }

  .banner-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  }

  .banner-image-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  .banner-card:hover .banner-image {
    transform: scale(1.1);
  }

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 40px;
    background: linear-gradient(135deg, rgba(243, 51, 51, 0.9), rgba(243, 51, 51, 0.7));
    opacity: 0;
    transition: opacity 0.4s ease;
  }

  .banner-card:hover .banner-overlay {
    opacity: 1;
  }

  .banner-content {
    color: white;
    z-index: 10;
    max-width: 280px;
  }

  .banner-title {
    font-size: 2.2rem;
    font-weight: 800;
    margin-bottom: 15px;
    text-transform: uppercase;
    letter-spacing: 2px;
    line-height: 1.2;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    animation: fadeInUp 0.6s ease forwards;
    opacity: 0;
    transform: translateY(20px);
  }

  .banner-card:hover .banner-title {
    animation-delay: 0.1s;
  }

  .banner-subtitle {
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 25px;
    line-height: 1.5;
    opacity: 0.95;
    animation: fadeInUp 0.6s ease forwards;
    opacity: 0;
    transform: translateY(20px);
  }

  .banner-card:hover .banner-subtitle {
    animation-delay: 0.2s;
  }

  .banner-button {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid rgba(255, 255, 255, 0.8);
    color: white;
    padding: 12px 24px;
    border-radius: 50px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 1px;
    backdrop-filter: blur(10px);
    animation: fadeInUp 0.6s ease forwards;
    opacity: 0;
    transform: translateY(20px);
  }

  .banner-card:hover .banner-button {
    animation-delay: 0.3s;
  }

  .banner-button:hover {
    background: white;
    color: #333;
    transform: translateX(5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }

  .button-arrow {
    font-size: 1.2rem;
    transition: transform 0.3s ease;
  }

  .banner-button:hover .button-arrow {
    transform: translateX(3px);
  }

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    .banner-card {
      height: 150px;
    }
    
    .banner-content {
      padding: 20px;
    }
    
    .banner-title {
      font-size: 1.8rem;
    }
    
    .banner-subtitle {
      font-size: 1rem;
    }
    
    .banner-button {
      padding: 10px 20px;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 480px) {
    .banner-card {
      height: 100px;
    }

    .banner-overlay {
      padding: 10px;
    }
    
    .banner-content {
      padding: 10px;
    }
    
    .banner-title {
      font-size: 12px;
      margin-bottom: 2px;
      transform: translateY(0);
    }
    
    .banner-subtitle {
      font-size: 10px;
      margin-bottom: 5px;
      transform: translateY(0);
      display: none;
    }
    
    .banner-button {
      padding: 10px;
      font-size: 10px;
      gap: 2px;
      padding: 8;
      transform: translateY(0);
      font-size: 8px;
    }
  }
`;

// Inject the CSS into the document head
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = internalCSS;
  document.head.appendChild(styleElement);
}

export default Banners;